/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * UI: Mobile Footer.
 */

import React from "react";

export const Footer = () => {
    return (
        <div className="container-fluid fixed-bottom footer-color footer-style">
            <div className="footer">
        <span className="footer-style-mobile">
          © Copyright 2023, 2024, 2025 Farelanes LLC. All Rights Reserved.
        </span>
            </div>
        </div>
    );
};